const motionGraphicData = [
  {
    id: 6,
    cardTitle: 'Motion Graphics',
    cardImage: 'assets/Von-motion.jpg',
    cardText: 'Animation for web banners and social media posts',
    cardLink: '/works/WorksDesc',
    video1: '/assets/von-motion1.mp4',
    title1: 'Grand Excelsior Promo Video - Social Media Post',

    video2: '/assets/Von-motion4.mp4',
    title2: 'Grand Excelsior Promo Video - Social Media Post',

    video3: '/assets/Von-motion2.mp4',
    title3: 'Social Listening - Instagram Post',

    video4: '/assets/Von-motion8.mp4',
    title4: 'Advertisers.store promo announcement - social media post',

    video5: '/assets/Von-motion10.mp4',
    title5: 'Dug Out Promo Announcement - Social Media post',

    video6: '/assets/Von-motion6.mp4',
    title6: 'Cobranding Adidas x Gucci - Social Media post'
  }
]

export default motionGraphicData;
